export default {
  "chua-phan-loai": {
    seoTitle: "Chưa phân loại",
    title: "Chưa phân loại",
  },
  "truyen": {
    seoTitle: "Truyện hay",
    title: "Truyện hay",
  },
  "hoi-dap": {
    seoTitle: "Hỏi đáp",
    title: "Hỏi đáp",
  },
};
//
// export default [
//   {
//     title: 'Học Excel',
//     slug: 'hoc-excel',
//     seoTitle:'Học Excel',
//   },
//   {
//     title: 'Học Word',
//     slug: 'hoc-word',
//   },
//   {
//     title: 'Học PowerPoint',
//     slug: 'hoc-powerpoint',
//   },
//   {
//     title: 'Học HTML',
//     slug: 'hoc-htnl',
//   },
//   {
//     title: 'Học Javascript',
//     slug: 'hoc-javascript',
//   },
//   {
//     title: 'Học CSS',
//     slug: 'hoc-css',
//   },
//   {
//     title: 'Học Bootstrap 4',
//     slug: 'hoc-bootstrap-4',
//   },
//   {
//     title: 'Học SEO',
//     slug: 'hoc-seo',
//   },
//   {
//     title: 'Học Wordpress',
//     slug: 'hoc-wordpress',
//   },
// ]